module.exports = __webpack_public_path__ + "static/media/57 - Sister Nancy - Bam Bam.0773cdb2.mp3";